<template>
  <Loader :loading="loading">
    <div v-if="hipscore && hipscore.length > 0" class="row" style="border: 1px solid #e0e0e0">
      <div class="d-flex col-12 justify-content-between px-3 py-2" style="background-color: #f8f8fb;">
        <div><h5 class="text-list-locomo-7 mb-1">履歴照会</h5></div>
      </div>
      <div class="p-0">
        <Spliter :initialLeftWidth="370">
          <template #left>
            <div class="col-12 px-1">
              <div class="mt-2 px-1">
                <b-button class="w-lg btn-edit" :disabled="listIds.length === 0" :class="{'bg-disabled': listIds.length === 0}" @click="exportExcel()">Excel出力</b-button>
              </div>
              <div class="table-responsive mt-2 mb-0 scroll" :style="{maxHeight: isExpand ? '65vh': '50vh'}">
                <vue-loadmore :on-refresh="onRefresh" :on-loadmore="onLoad" loading-text="読み込み中" :finished="finished" finished-text=" ">
                  <table class="table align-middle mb-0">
                    <tbody>
                      <tr v-for="(data, index) in hipscore" :key="index"
                        @click="bulderChart(data, index), (clickIndex = index), getAnswersId(index)" style="cursor: pointer">
                        <td class="text-center pe-1" :class="{ 'bg-active-locomo': index === clickIndex }">
                          <input class="form-check-input" type="checkbox" @click="checkedLocomo(data.uuid)"
                            id="formCheckRight2" :checked="isChecked(data.uuid)" style="font-size: 24px; margin: 0;"/>
                        </td>
                        <td :class="{ 'bg-active-locomo': index === clickIndex }" class="px-1" width="54%">
                          <h5 class="text-list-locomo-7 mb-0">
                            {{ data.created_at | fomatDate2 }}
                          </h5>
                        </td>
                        <td width="50%" style="min-width: 120px;" class="text-start px-1"
                          :class="{ 'bg-active-locomo': index === clickIndex }">
                          <h5 class="mb-0 text-list-locomo-7 text-right">股関節スコア1</h5>
                          <h5 class="mb-0 text-list-locomo-7 text-right">股関節スコア2</h5>
                        </td>
                        <td width="50%" :class="{ 'bg-active-locomo': index === clickIndex }" class="px-1"
                          style="min-width: 100px;">
                          <h5 class="mb-0 text-list-locomo-7 text-right">
                            {{ data.sub_histories | filterCurrentScore }} /
                            {{ data.sub_histories | filterMaxScore }}
                            {{ $t("menuitems.hospital.points") }}
                          </h5>
                          <h5 class="mb-0 text-list-locomo-7 text-right">
                            {{ data.current_harris }} /
                            {{ data.max_harris }}
                            {{ $t("menuitems.hospital.points") }}
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </vue-loadmore>
              </div>
            </div>
          </template>

          <template #right>
            <div class="col-12 px-3 mb-3">
              <div class="mt-4 mb-4 d-flex justify-content-between">
                <h5 class="text-list-locomo-7">
                  {{ $t("menuitems.hospital.detail") }}
                </h5>
              </div>
              
              <div class="row mb-12 scroll" :style="{maxHeight: isExpand ? '60vh': '50vh'}">
                <div class="col-xl-6">
                  <h5>{{ $t("menuitems.hospital.radarChart") }}</h5>
                  <div>
                    <RadarChart :size="`${370 * (screenWidth / 1920)}`" :rectWidth="`${30 * (screenWidth / 1920)}`"
                      :rectHeight="`${20 * (screenWidth / 1920)}`" :data="getDataChart()" />
                  </div>
                </div>
                <div class="col-xl-6">
                  <h5>{{ $t("menuitems.hospital.harris") }}</h5>
                  <h1 class="mb-0 text-list-locomo-7 text-left color-red">
                    {{ hipscore[clickIndex].current_harris }} /
                    {{ hipscore[clickIndex].max_harris}}
                    {{ $t("menuitems.hospital.points") }}
                  </h1>
                  <div>
                    痛みや日常生活に支障が出ない程度に注意をしながら、アプリの動画を参照して運動を行いましょう。
                  </div>
                  <div>
                    ※本サイトに掲載されている医療情報は、医師の監修を受けていますが、症状には個人差があるため、詳しくは専門医にご相談ください。
                  </div>
                </div>
                <div class="col-12" v-if="tempAnswer.length > 0 && hipscoreQuestion">
                  <div class="m-2" v-for="(question, index) in hipscoreQuestion" :key="index">
                    <div v-for="(subQuestion, id) in question" :key="id">
                      <h6 class="text-answers">
                        {{ subQuestion ? subQuestion.description : '' }}
                      </h6>
                      <div>
                        <span v-for="(answer, i) in subQuestion.answers" :key="i" class="form-radio-outline form-radio-success" style="display: block;">
                          <span class="d-block" v-if="answer && hipscore[clickIndex].current_harris != null">
                            <input class="form-check-input mt-2" size="lg" style="margin-right: 1em; -webkit-transform: scale(1.5)"
                              type="radio" :name="`index${subQuestion.uuid}`" :id="`index${answer.uuid}`"
                              v-model="tempAnswer[index][id]" :value="answer.id" :disabled="!tempAnswer[index] || !tempAnswer[index].includes(answer.id)" />
                            <label :for="`index${answer.uuid}`" class="label-answers" :class="[{'color-locomo': tempAnswer[index] && tempAnswer[index].includes(answer.id) }]"
                              >{{ answer ? answer.value : "" }}</label>
                          </span>
                          <span class="d-block" v-if="answer && hipscore[clickIndex].current_harris === null">
                            <input class="form-check-input mt-2" size="lg" style="margin-right: 1em; -webkit-transform: scale(1.5)"
                              type="radio" :name="`index${subQuestion.uuid}`" :id="`index${answer.uuid}`"
                              :value="answer.id" :disabled="!tempAnswer || !tempAnswer.includes(answer.id)" />
                            <label :for="`index${answer.uuid}`" class="label-answers"
                              >{{ answer ? answer.value : "" }}</label>
                          </span>
                        </span>
                        <div v-if="subQuestion.answers.length == 0 && hipscore[clickIndex].current_harris != null">
                          <label :for="`index${subQuestion.answers.uuid}`" class="label-answers color-locomo ms-3">
                            {{ tempAnswer[index][tempAnswer[index].length - 5 + id] ? tempAnswer[index][tempAnswer[index].length -5 + id] : '回答なし' }}
                          </label>
                        </div>
                        <div v-if="subQuestion.answers.length == 0 && hipscore[clickIndex].current_harris === null">
                          <label :for="`index${subQuestion.answers.uuid}`" class="label-answers color-locomo ms-3">
                            {{ '回答なし' }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </Spliter>
      </div>
    </div>
    <div v-else class="undefine">
      <img src="@/assets/images/no-data.jpg" alt="" />
      <div class="mt-3">詳細データはありません。</div>
    </div>
  </Loader>
</template>

<script>
import RadarChart from "@/components/radar/index.vue";
import { filter } from "../../helpers/Vue-Filter";
import Loader from "../../components/widgets/loader.vue";
import { hospitalMethods } from "@/state/helpers";
import { hospitalComputed } from "@/state/helpers";
import {getProfile} from "../../helpers/Auth";
import api from "@/api";
import moment from 'moment';
import Spliter from "./spliter.vue";

export default {
  components: {
    RadarChart,
    Loader,
    Spliter,
  },

  filters: {
    ...filter,
  },

  props: ["hipscore", "pagination", "userInfor", "isExpand"],

  data() {
    return {
      bars: [
        { id: 1, background: "primary", name: "痛み" },
        { id: 2, background: "success", name: "歩行能力" },
        { id: 3, background: "warning", name: "日常生活動能力" },
        { id: 4, background: "secondary", name: "転倒危険性" },
        { id: 5, background: "pink", name: "可動域" },
      ],
      chart: null,
      loading: false,
      clickIndex: 0,
      screenWidth: 1920,
      widthDesktop: 1024,

      enabledExportPDF: false,
      edit: false,
      flagPDFAll: false,
      listIds: [],

      list: [],
      page: 1,
      finished: false,

      role: getProfile().role.name,
      resultAnswer: [],
      tempAnswer: [],
      hipscoreQuestion: [],
      hipscoreIndex: 0,
    };
  },

  watch: {
    hipscore: {
      handler() {
        try {
          this.loading = true;
          if (this.hipscore && this.hipscore.length > 0) {
            this.hipscore[0].sub_histories.forEach((e, index) => {
              this.bars[index].value = (
                (e.current_score / e.max_score) *
                10
              ).toFixed(1);
            });

            this.getAnswersId(this.hipscoreIndex);
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error);
        } finally {
          this.loading = false;
        }
      },
      deep: true,
    },
  },

  async created() {
    await this.getQuestionHipscore(this.role).then((res) => {
      this.hipscoreQuestion = res;
    })
    const questionData = [];
    this.hipscoreQuestion.forEach((i) => {
      questionData.push(i.sub_questions);
    });
    questionData.splice(4, 1)
    this.hipscoreQuestion = questionData;
    window.addEventListener("resize", this.myEventHandler);
    if (!this.hipscore || this.hipscore.length == 0) {
      return;
    } else {
      this.chart = this.hipscore[0];
      this.hipscore[0].sub_histories.forEach((e, index) => {
        this.bars[index].value = ((e.current_score / e.max_score) * 10).toFixed(
          1
        );
      });
      this.getAnswersId(this.hipscoreIndex);
    }
    this.myEventHandler();
  },

  mounted() {
    this.fetchPage();
  },

  computed: {
    ...hospitalComputed,
  },

  methods: {
    ...hospitalMethods,

    onRefresh(done) {
      this.list = [];
      this.page = this.page;
      this.finished = false;
      this.fetchPage();

      done();
    },

    onLoad(done) {
      if (this.page <= this.pagination.last_page) {
        this.loadMore();
      } else {
        // all data loaded
        this.finished = true;
      }
      done();
    },

    fetchPage() {
      for (let i = 0; i <= this.pagination.last_page; i++) {
        this.list.push(this.list.length + 1);
      }
      this.page++;
    },

    loadMore() {
      this.$emit("loadMoreHipscore");
      this.page++;
    },

    async getAnswersId(index) {
      try {
        const uuid = this.hipscore[index].uuid;
        const dataId = this.hipscore.find((e) => e.uuid === uuid);
        this.hipscoreIndex = index;
        if (!dataId || !dataId.answer) {
          return;
        } else {
          this.resultAnswer = dataId.answer.map((item) =>
            item.result.map((i) => {
              if (i.id != null) {
                return parseInt(i.id);
              } else {
                return i.text;
              }
            })
          );
          this.tempAnswer = JSON.parse(JSON.stringify(this.resultAnswer));
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    bulderChart(data, index) {
      this.chart = data;
      this.clickIndex = index;
      this.hipscore[index].sub_histories.forEach((e, index) => {
        this.bars[index].value = ((e.current_score / e.max_score) * 10).toFixed(
          1
        );
      });
    },

    myEventHandler() {
      // eslint-disable-next-line no-console
      this.screenWidth =
        window.innerWidth < this.widthDesktop
          ? this.widthDesktop
          : window.innerWidth;
    },

    checkedLocomo(id) {
      const arraycontainsturtles = this.listIds.findIndex(function (item) {
        return item.indexOf(id) !== -1;
      });
      if (arraycontainsturtles >= 0) {
        this.listIds.splice(arraycontainsturtles, 1);
      } else {
        this.listIds.push(id);
      }
    },

    isChecked(uuid) {
      if (this.listIds.includes(uuid)) return true;
      return false;
    },

    isCheckedAll() {
      if (this.hipscore.length === this.listIds.length) return true;
      return false;
    },

    selectAll($event) {
      this.flagPDFAll = $event.target.checked;
      if (!this.flagPDFAll) {
        this.listIds = [];
      } else {
        this.listIds = this.hipscore.map((e) => e.uuid);
      }
    },

    exportPDF() {
      if (this.flagPDFAll && this.listIds.length === this.hipscore.length) {
        this.$emit("exportPDFHipcores");
      } else {
        this.$emit("exportPDFHipscore", this.listIds);
      }

      this.listIds = [];
      this.flagPDFAll = false;
    },

    exportExcel() {
      const payload = {};
      payload.ids = this.listIds.toString();
      try {
        const formattedDate = moment().format('YYYYMMDD');
        api.exportHistory('joa-hipscore', payload, `運動機能チェック_${this.userInfor.mobile}_${this.userInfor.patient_id}_${formattedDate}`);
      } catch (error) {
        console.log(error);
      }
    },

    exportPDFHispcores() {},

    exportPDFHipscore() {},

    getDataChart() {
      // eslint-disable-next-line no-console
      return  this.hipscore[this.clickIndex].sub_histories.map((x) => ({
        current_score: x.current_score,
        max_score: x.max_score,
      }));
    },

    checkedAnswerLocomo(answer_id, index) {
      let answer = JSON.parse(JSON.stringify(this.tempAnswer));

      if(answer){
        answer[index] = answer_id;
      }
    },
  },

  computed: {},
};
</script>

<style scoped>
* {
  font-family: "Noto Sans JP";
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1;
  /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1;
  /* Firefox */
}

.text-list-locomo-7 {
  color: #404040;
  font-size: 16px;
  font-weight: 700;
}

.text-answers {
  color: #404040;
  font-size: 16px;
}

.label-answers {
  color: #b1adad;
  font-size: 16px;
}

.text-list-time {
  color: #404040;
  font-weight: 400;
  font-size: 14px;
}

.text-table {
  color: #404040;
}

.text-link {
  color: #336aff;
}

.color-red {
  color: red;
}

.bg-active-locomo {
  background: #b8e060;
}

.text-end {
  align-items: end;
}

.color-locomo {
  color: #404040 !important;
}

.undefine {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #404040;
}

::v-deep .progress .bg-primary {
  background: #9571fc !important;
}

::v-deep .progress .bg-success {
  background: #32bab1 !important;
}

::v-deep .progress .bg-warning {
  background: #f7a659 !important;
}

::v-deep .progress .bg-secondary {
  background: #7d9994 !important;
}

::v-deep .progress .bg-pink {
  background: #fb84b1 !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.scroll {
  max-height: 50vh;
  overflow-y: scroll;
}

.table-content {
  height: 50vh;
}

.select-all {
  overflow-y: scroll;
}

.text-right {
  text-align: right;
}

.btn-edit {
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
  margin-left: 24px;
}

.bg-disabled {
  background: #ffffff !important;
  color: #d3d3d3 !important;
}
</style>
